import { render, staticRenderFns } from "./MainBottomBar.vue?vue&type=template&id=084ade50&scoped=true"
import script from "./MainBottomBar.vue?vue&type=script&lang=js"
export * from "./MainBottomBar.vue?vue&type=script&lang=js"
import style0 from "./MainBottomBar.vue?vue&type=style&index=0&id=084ade50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084ade50",
  null
  
)

export default component.exports